/**
 * @generated SignedSource<<e1532962dc1190af4b54c9779a7c9e7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLSmartSyncStatus = "ACTIVE" | "BACKFILLING" | "DISABLED" | "%future added value";
export type UpdateSmartSyncInput = {
  days?: number | null | undefined;
  enabled: boolean;
  integrationId: any;
};
export type GitHubIntegrationsDialogUpdateSmartSyncMutation$variables = {
  input: UpdateSmartSyncInput;
};
export type GitHubIntegrationsDialogUpdateSmartSyncMutation$data = {
  readonly updateSmartSync: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly id: any;
      readonly smartSyncSettings: {
        readonly backfillError: string | null | undefined;
        readonly days: number;
        readonly status: GraphQLSmartSyncStatus;
      } | null | undefined;
    } | null | undefined;
  };
};
export type GitHubIntegrationsDialogUpdateSmartSyncMutation = {
  response: GitHubIntegrationsDialogUpdateSmartSyncMutation$data;
  variables: GitHubIntegrationsDialogUpdateSmartSyncMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateSmartSyncPayload",
    "kind": "LinkedField",
    "name": "updateSmartSync",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSmartSyncSettings",
            "kind": "LinkedField",
            "name": "smartSyncSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "days",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "backfillError",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GitHubIntegrationsDialogUpdateSmartSyncMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GitHubIntegrationsDialogUpdateSmartSyncMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "758e43946631d9e564fef2b2f9af2c2a",
    "id": null,
    "metadata": {},
    "name": "GitHubIntegrationsDialogUpdateSmartSyncMutation",
    "operationKind": "mutation",
    "text": "mutation GitHubIntegrationsDialogUpdateSmartSyncMutation(\n  $input: UpdateSmartSyncInput!\n) {\n  updateSmartSync(input: $input) {\n    integration {\n      id\n      smartSyncSettings {\n        days\n        status\n        backfillError\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9e8f3dbfa4df253142730290b9fdf17";

export default node;
